



// @ts-nocheck
import Countup from "./countup";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class PfCountRoll extends Vue {
  @Prop() public endVal!: number; // 结束值，必填
  @Prop({ default: true }) public start?: boolean; // 能否执行动画，默认true
  @Prop({ default: 1 }) public startVal?: number; // 起始值
  @Prop({ default: 0 }) public decimals?: number; // 小数位数，默认不要小数部分
  @Prop({ default: () => ({}) }) public options?: object;

  private duration = 2;
  private countValue = 0;
  private countup = null;

  @Watch("start") private watchStart(val) {
    if (val) {
      this.countup.start();
    }
  }
  @Watch("endVal") private watchEndVal(val) {
    this.countup.update(val);
  }

  private mounted() {
    this.$nextTick(() => {
      this.countup = new Countup(
        this.startVal,
        this.endVal,
        this.decimals,
        this.duration,
        this.options,
      );
      if (this.start) {
        this.countup.start((vals) => {
          this.countValue = vals;
        });
      }
    });
  }
}
